import WebLayout from './VerificationCodeInputLayout.web';
import MobileLayout from './VerificationCodeInputLayout.mobile';
import { isReactNative } from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout; 